import { Chip, makeStyles, Tooltip, Typography } from '@material-ui/core'
import { RunnableTaskStatus } from 'model/Project/BoMItemRow'
import React from 'react'

type Props = {
  runningLabel: string
  category: string
  status: RunnableTaskStatus
  onClick?: () => void
  title?: React.ReactNode
  finishedLabel: React.ReactNode
  running: boolean
}

const useStyles = makeStyles(() => ({
  bomItemBadge: {
    padding: 0,
    '& .MuiChip-label': {
      padding: 0,
    },
  },
}))

// const BadgeIcon = (props: { status: Props['status'] }) => {
//   switch (props.status) {
//     case RunnableTaskStatus.Failed:
//       return <ErrorOutlineOutlined />
//     case RunnableTaskStatus.Done:
//       return <CheckOutlined />
//     case RunnableTaskStatus.Requested:
//       return <ScheduleOutlined />
//     case RunnableTaskStatus.Running:
//       return <CircularProgress size="small" />
//     default:
//       return <CheckOutlined />
//   }
// }

const RunnableTaskStatusToColor = (taskStatus: RunnableTaskStatus) => {
  switch (taskStatus) {
    case RunnableTaskStatus.NotApplicable:
      return 'transparent'
    case RunnableTaskStatus.Requested:
      return 'info'
    case RunnableTaskStatus.Running:
      return 'info'
    case RunnableTaskStatus.Done:
      return 'success'
    case RunnableTaskStatus.Failed:
      return 'error'
    default:
      return 'info'
  }
}

const useChipLabelClasses = makeStyles((theme) => ({
  rootChipLabel: {
    display: 'flex',
    padding: 0,
    margin: 0,
    alignItems: 'center',
  },
  chipTitle: {
    // backgroundColor: theme.palette.action.disabled,
    padding: theme.spacing(0.25, 1, 0),
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    height: '24px',
    verticalAlign: 'center',
    borderRight: `2px solid ${theme.palette.divider}`,
  },
  chipLabel: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fontWeight: theme.typography.fontWeightBold as any,
    padding: theme.spacing(1),
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    backgroundColor: (props: {
      color: ReturnType<typeof RunnableTaskStatusToColor>
    }) => (theme.palette[props.color] || theme.palette.info).main,
    color: (props: { color: ReturnType<typeof RunnableTaskStatusToColor> }) =>
      (theme.palette[props.color] || theme.palette.info).contrastText,
  },
}))

const ChipLabel = (props: {
  category: string
  label: React.ReactNode
  color: ReturnType<typeof RunnableTaskStatusToColor>
}) => {
  const classes = useChipLabelClasses({ color: props.color })

  return (
    <span className={classes.rootChipLabel}>
      <Typography variant="caption" className={classes.chipTitle}>
        {props.category}
      </Typography>
      <Typography
        variant="caption"
        className={classes.chipLabel}
        component="span"
      >
        {props.label}
      </Typography>
    </span>
  )
}

export const BoMItemBadge = (props: Props) => {
  const color = RunnableTaskStatusToColor(props.status)

  const classes = useStyles({ color })

  return (
    <Tooltip title={props.title} arrow interactive>
      <Chip
        className={classes.bomItemBadge}
        onClick={props.onClick}
        component={'span'}
        label={
          <ChipLabel
            {...props}
            label={props.running ? props.runningLabel : props.finishedLabel}
            color={color}
          />
        }
        size="small"
        variant="outlined"
      />
    </Tooltip>
  )
}
